<!-- 系统用户管理 -->
<template>
  <div class="campus-announcement">
    <!-- 系统用户管理 -->
    <div class="left-box" v-if="JSON.stringify(detailsItem) != '{}'">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
        <el-form-item label="用户名" prop="userName" label-width="100px" >
          <el-input v-model="ruleForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="设置密码"   label-width="100px" >
          <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码"    label-width="100px">
          <el-input type="password" v-model="ruleForm.confirmPassWord"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱"   label-width="100px">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="手机" label-width="100px">
          <el-input v-model="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="城市"  label-width="100px">
          <el-input v-model="ruleForm.address" placeholder="请在城市后面输入（市）"></el-input>
        </el-form-item>
        <el-form-item label="别名"  label-width="100px">
          <el-input v-model="ruleForm.alias"></el-input>
        </el-form-item>
        <el-form-item label="网站名"  label-width="100px">
          <el-input v-model="ruleForm.siteName"></el-input>
        </el-form-item>
      
        <el-form-item label="类型选择"  class="leixingtype"   label-width="100px">
          <!-- <el-input v-model="ruleForm.email"></el-input> -->
          <el-select filterable v-model="user_type"   placeholder="请选择组织类型">
              <el-option
                v-for="item in leixinG"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
     
        <el-form-item label="定位转发接口"  label-width="100px">
          <el-input v-model="ruleForm.locSyncInterFace"></el-input>
        </el-form-item>
        <!-- <el-form-item label="定位转发接口1" prop="" label-width="100px">
          <el-input v-model="ruleForm."></el-input>
        </el-form-item> -->
        <!--  -->
        <el-form-item label="型号"   label-width="100px">
          <!-- <el-input v-model="ruleForm.email"></el-input> -->
          <el-select filterable v-model="value1" multiple placeholder="请选择型号">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label-width="100px">
          <el-button type="success"  v-if="statustile == '详情'"
              @click="addSuboptionClick">添加子选项</el-button>
            <!-- <el-button type="primary" v-if="anniuTile=='详情' || anniuTile=='修改'" @click="">修改</el-button> -->
            <el-button type="danger" @click="deleteClick" v-if="statustile == '详情'" >删除</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" >提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="right-box">
      <el-tree :data="dataList" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
    </div>
    
  </div>
</template>

<script>
import { setSystemUserTree,menuGetRTree} from '@/assets/api/api.js'
import { menuGetUserById,menusaveOrUpdateUser,deleteUserById} from '@/assets/api/user.js'
export default {
  components: {

  },
  data() {
      return {
        value1:[],
        options:[],
        ruleForm:{
          userName:'',
          password:"",
          confirmPassWord:"",
          email:"",
          mobile:"",
          alias:"",
          siteName:"",
          address:"",
          locSyncInterFace:"",
          id:''
        },
        defaultProps: {
          children: 'children',
          label: 'username'
        },
        user_type:'',
      leixinG:[
        {
          value:'school',
          label:'学校类型',
       },
       {
          value:'organization',
          label:'组织类型',
       },
       {
          value:'oldPeople',
          label:'老人类型',
       }
    ],
      dataList: [],
        rules: {
          userName: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          // email: [
          //   { required: true, message: '请输入邮箱', trigger: 'change' }
          // ],
          // mobile: [
          //   { required: true, message: '请输入手机号', trigger: 'change' }
          // ],
      },
      detailsItem: {},
      statustile: '详情'
      };
  },
  created() {
    this.setSystemUserTree()
    this.xinghaotree()
  },
  mounted() {

  },
  watch : {
    value1 (value) {
      console.log(value);
    }
  },
  methods: {
    xinghaotree(){
      let params = {
                
              }
              menuGetRTree(params).then((res)=> {
                  console.log(res,res.data.data.children,'获取--型号下拉框');
                  this.options =  res.data.data.children
              }).catch((err)=> {
                  console.log(err);
              })
    },
    addSuboptionClick () {
      this.value1 = []
      this.ruleForm.userName = ''
      this.ruleForm.email = ''
      this.ruleForm.mobile = ''
      this.ruleForm.alias = ''
      this.ruleForm.address = ''
      this.ruleForm.siteName = ''
      this.ruleForm.locSyncInterFace = ''
      this.statustile = '添加子选项'
      console.log('添加子选项');
    },
    deleteClick () {
      deleteUserById({userId :this.detailsItem.id}).then((res) => {
          this.setSystemUserTree()
          this.detailsItem = {}
          this.statustile ='详情'
          this.$message({
            type: 'success',
            message: '删除成功'
          });
        }).catch((err) => {
          console.log(err,'删除失败');
          
        })
      console.log('删除');
    },  
    submitForm(ruleForm){
      this.$refs[ruleForm].validate((valid) => {
      if (valid) {
        // console.log(valid,'tongguo');
        this.menusaveOrUpdateUserSeacher()
      } else {
          console.log(valid,'校验未通过');
          return false;
      }
      });
    },
    //修改
    menusaveOrUpdateUserSeacher(){
      if ( this.statustile == '详情' ) {
        let str = this.value1.toString();
        const params = {
            aliasName:this.ruleForm.alias,
            confirmPassWord:this.ruleForm.confirmPassWord,
            email:this.ruleForm.email,
            locSyncInterface:this.ruleForm.locSyncInterFace,
            mobile:this.ruleForm.mobile,
            passWord:this.ruleForm.password,
            siteName:this.ruleForm.siteName,
            address:this.ruleForm.address,
            userName:this.ruleForm.userName,
            userId:this.ruleForm.id,
            userType:this.user_type ? this.user_type :'school',
            dictionaryId:str

        }
        console.log(params,99999999999999);
        menusaveOrUpdateUser(params).then((res) => {
          console.log(res,'修改成功');
          this.setSystemUserTree()
          this.detailsItem = {}
          this.statustile ='详情'
          this.$message({
            type: 'success',
            message: '修改成功'
          });
        }).catch((err) => {
          console.log(err,'修改失败');
          
        })
      } else if ( this.statustile == '添加子选项' ) {
        // let str = [...this.value1].join(',');
        let str = this.value1.toString();
        const params = {
            aliasName:this.ruleForm.alias,
            confirmPassWord:this.ruleForm.confirmPassWord,
            email:this.ruleForm.email,
            locSyncInterface:this.ruleForm.locSyncInterFace,
            mobile:this.ruleForm.mobile,
            passWord:this.ruleForm.password,
            siteName:this.ruleForm.siteName,
            userName:this.ruleForm.userName,
            address:this.ruleForm.address,
            // userId:this.ruleForm.id,
            parentId: this.detailsItem.id,
            userType:this.user_type ? this.user_type :'school',
            dictionaryId:str
        }
        menusaveOrUpdateUser(params).then((res) => {
          console.log(res,'新增成功');
          this.setSystemUserTree()
          this.detailsItem = {}
          this.statustile ='详情'
          this.$message({
            type: 'success',
            message: '新增成功'
          });
        }).catch((err) => {
          console.log(err,'新增失败');
        })
        console.log('新增参数',params);
      }
    },

   //详细数据
   handleNodeClick(data){
    // console.log();
    this.detailsItem = data
      const params = {
        userId:data.id
      }
      menuGetUserById(params).then((res)=> {
        console.log(res,'成功123');
        this.ruleForm.userName = res.data.data.username
        this.ruleForm.email = res.data.data.email
        this.ruleForm.mobile = res.data.data.mobile
        this.ruleForm.alias = res.data.data.alias
        this.ruleForm.siteName = res.data.data.siteName
        this.ruleForm.address = res.data.data.address
        this.user_type = res.data.data.userType
        
        this.ruleForm.locSyncInterFace = res.data.data.locSyncInterface
        this.value1 = res.data.data.dictionaryIds.split(',')
        if (this.value1 != []) {
          this.value1.forEach( item => {
                    item.label =  item.name
                    item.value = item.id
              
                })
        }
        

      }).catch((err) => {
        console.log(err,'失败');
      })
      this.ruleForm.id = data.id
      
    },
    //用户树
    setSystemUserTree() {
      let params = {
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      setSystemUserTree(params).then((res) => {
        console.log(res, '用户树--接口');
        this.dataList = res.data.data
      }).catch((err) => {
        console.log(err);
      })
    },
  },
};
</script>

<style scoped lang="scss">
.campus-announcement {
  height: 96%;
  background-color: #fff;
  display: flex;
  overflow: auto;
  .left-box{
    margin-top: 40px;
    width: 50%;
    margin-left: 60px;
    // background-color: pink;
    .leixingtype{
      // height: 35px;
      :deep() {
        .el-select--small .el-select__wrapper{
          height: 35px;
        }
      }
    }
    :deep() {
    
      .el-input--small .el-input__inner{
        height: 35px;
      }
      .el-form-item--small {
        width: 75%;
      }
      .el-button--small{
        // margin-left: 250px;
        margin: 8px;
      }
      .el-select .el-input{
        height: 40% !important;
        width: calc(180% - 20px);
        float: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        // width: 170%;
      }
      .el-select .el-select__tags-text {
        color: #000000;
      }

    }

  }
  .right-box{
    width: 100%;
    height: 80%;
    overflow: auto;
    // background-color: skyblue;
    margin-top: 40px;
  }
}
</style>
